import {
  IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle,
  IonCheckbox,
  IonCol,
  IonContent,
  IonGrid,
  IonItem,
  IonLabel,
  IonLoading, IonModal,
  IonPage,
  IonRow, IonText, IonToast,
  useIonRouter,
} from "@ionic/react";
import React, {useState} from "react";
import {useLocation} from "react-router-dom";
import Header from "../../components/Header";
import {AuthContext} from "../../providers/authContext";
import "./Page.css";
import userService from "../../services/UserService";
import {User} from "../entities/User";
import {KullaniciTip} from "../../enums/KullaniciTip";
import {ROLE} from "../../enums/ROLE";
import {Button} from "primereact/button";
import {REGISTER_USER, SERVER_URL} from "../../services/constants";
import {logError} from "../../utils";

const EdevletLogin: React.FC = () => {
  const {kurumBilgileri, setTitle, logIn} = React.useContext(AuthContext);
  const [aggreed, setAggreed] = useState<boolean>(false);
  const [kvkkOk, setKVKKOk] = useState<boolean>(false);
  const [secInfoOk, setSecInfoOk] = useState<boolean>(false);
  const [showAggrementModal, setShowAggrementModal] = useState<boolean>(false);
  const [showKVKKModal, setShowKVKKModal] = useState<boolean>(false);
  const [showSecInfoModal, setShowSecInfoModal] = useState<boolean>(false);
  const navigation = useIonRouter();
  const [newUser, setNewUser] = useState<string | null>();
  const [error, setError] = useState<string | null>();
  const [errorMessage, setErrorMessage] = useState<string | null>();
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<string>();
  const location = useLocation();

  React.useEffect(() => {
    setTitle("E-Devlet ile Giriş");
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get("error")) {
      setError(searchParams.get("error"));
      setErrorMessage(searchParams.get("error_description"));
    } else if (searchParams.get("newUser")) {
      setNewUser(searchParams.get("newUser"));
    } else {
      const user = new User(
        {
          sicilNo: -1,
          tip: KullaniciTip.BIREYSEL,
          adSoyad: undefined,
          menus: [],
        },
        ROLE.User,
        searchParams.get("user")!,
        searchParams.get("token")!
      );
      userService
        .login(user)
        .then(async () => {
          await logIn(user);
          navigation.push("/page/MemberWelcome", "root");
        })
        .catch((error) => {
          logError(error);
          setError("Hata");
          setErrorMessage(error.response ? error.response.data.message : error);
        })
        .finally(() => setShowLoading(false));
    }
  }, []);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    if (!aggreed) {
      e.preventDefault();
      setShowToastMessage(
        "Lütfen üyelik sözleşmesi onay kutusunu işaretleyiniz !"
      );
      return false;
    }
    if (!kvkkOk) {
      e.preventDefault();
      setShowToastMessage("Lütfen KVKK onay kutusunu işaretleyiniz !");
      return false;
    }
    if (!secInfoOk) {
      e.preventDefault();
      setShowToastMessage(
        "Lütfen Güvenlik uyarıları onay kutusunu işaretleyiniz !"
      );
      return false;
    }
    return true;
  }

  return (
    <IonPage>
      <Header/>
      <IonContent fullscreen>
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={"Lütfen Bekleyin..."}
        />
        <IonToast
          isOpen={showToastMessage !== undefined}
          onDidDismiss={() => setShowToastMessage(undefined)}
          message={showToastMessage}
          duration={15000}
          position="top"
          buttons={[
            {
              text: "Tamam",
              role: "cancel",
            },
          ]}
        />
        {error && (
          <IonItem>
            <IonGrid>
              <IonRow className="ion-text-start ion-align-items-center">
                <IonCol size="1">
                  <img src="assets/denied.png" alt="denied.png"/>
                </IonCol>
                <IonCol>
                  <IonLabel color="danger">{error}</IonLabel>
                </IonCol>
              </IonRow>
              <IonRow className="ion-text-start ion-align-items-center">
                <IonCol size="1"></IonCol>
                <IonCol>
                  <IonLabel color="danger">{errorMessage}</IonLabel>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonItem>
        )}
        {newUser && (
          <IonCard className="custom-card-content">
            <IonCardContent>
            <form onSubmit={(e) => handleSubmit(e)} method="post" action={`${REGISTER_USER}/2/${newUser}`}>
              <IonGrid>
                <IonRow>
                  <IonCol size="12" sizeSm="7" offsetSm="2">
                    <IonItem color="light">
                      <IonText>Sistemimize ait bir üyeliğiniz bulunmamaktadır. Üye olmak için aşağıdaki koşulları kabul edip <strong>Yeni Üyelik Oluştur</strong> butonuna tıklayınız.</IonText>
                    </IonItem>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol size="12" sizeSm="7" offsetSm="2">
                    <IonItem color="light">
                      <Button
                        type="button"
                        className="p-button-link"
                        onClick={() => setShowAggrementModal(true)}
                      >
                        Üyelik sözleşmesini okudum kabul ediyorum.
                      </Button>
                      <IonCheckbox
                        color="primary"
                        checked={aggreed}
                        slot="start"
                        onIonChange={(e) => setAggreed(e.detail.checked)}
                      ></IonCheckbox>
                    </IonItem>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol size="12" sizeSm="7" offsetSm="2">
                    <IonItem color="light">
                      <Button
                        type="button"
                        className="p-button-link"
                        onClick={() => setShowKVKKModal(true)}
                      >
                        KVKK bilgilendirmesini okudum kabul ediyorum.
                      </Button>
                      <IonCheckbox
                        color="primary"
                        checked={kvkkOk}
                        slot="start"
                        onIonChange={(e) => setKVKKOk(e.detail.checked)}
                      ></IonCheckbox>
                    </IonItem>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol size="12" sizeSm="7" offsetSm="2">
                    <IonItem color="light">
                      <Button
                        type="button"
                        className="p-button-link"
                        onClick={() => setShowSecInfoModal(true)}
                      >
                        Güvenlik uyarılarını okudum kabul ediyorum.
                      </Button>
                      <IonCheckbox
                        color="primary"
                        checked={secInfoOk}
                        slot="start"
                        onIonChange={(e) => setSecInfoOk(e.detail.checked)}
                      ></IonCheckbox>
                    </IonItem>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol size="10" sizeSm="6" offset="2" offsetSm="4">
                    <IonButton type="submit">Yeni Üyelik Oluştur</IonButton>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </form>
            <IonModal
              isOpen={showAggrementModal}
              canDismiss
              className="disclaimer-modal"
              onDidDismiss={() => setShowAggrementModal(false)}
            >
              <IonContent className="ion-text-center">
                <IonCard>
                  <IonCardHeader>
                    <IonCardTitle>
                      İNTERNET HİZMETLERİ KULLANIM SÖZLEŞMESİ
                    </IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent>
                    <p style={{textAlign: "justify"}}>
                  <span style={{textAlign: "justify"}}>
                    İnternet ortamında {kurumBilgileri?.kisaTanim}'ne,
                    tarafımdan verilen bilgilerimin doğru olduğunu, bu bilgilere
                    göre internet ortamında {kurumBilgileri?.kisaTanim}{" "}
                    bilgisayar sistemindeki kişisel bilgilerimi sorgulama ve
                    diğer işlemler için {kurumBilgileri?.kisaTanim} tarafından
                    verilen ve tarafımca değiştirilecek olan kişisel şifrenin
                    korunması ile internet üzerinden kredi kartı ile yapacağım
                    işlemlerde her türlü riskin tarafıma ait olduğunu,{" "}
                    {kurumBilgileri?.kisaTanim}'nin unutulmuş, çalınmış veya
                    kaybedilmiş olan kullanıcı kodu ve kişisel şifremden,
                    bunların üçüncü kişiler tarafından kullanılmasından ve
                    sonuçlarından hiçbir şekilde sorumlu olmadığını kabul
                    ediyorum.
                  </span>
                    </p>
                  </IonCardContent>
                </IonCard>
                <IonButton onClick={() => setShowAggrementModal(false)}>
                  Tamam
                </IonButton>
              </IonContent>
            </IonModal>
            <IonModal
              isOpen={showKVKKModal}
              canDismiss
              className="disclaimer-modal"
              onDidDismiss={() => setShowKVKKModal(false)}
            >
              <IonContent className="ion-text-center">
                <IonCard>
                  <IonCardContent>
                    <h3>
                      <b>
                        E-BELEDİYE HİZMETLERİNE ve BAŞVURULARINA İLİŞKİN AYDINLATMA
                        METNİ
                      </b>
                    </h3>

                    <div style={{textAlign: "justify"}}>
                  <span style={{textAlign: "justify"}}>
                    <h6>
                      Değerli Vatandaşlarımız; Kişisel verilerin işlenmesinde
                      başta özel hayatın gizliliği olmak üzere kişilerin temel
                      hak ve özgürlüklerini korumak ve kişisel verileri işleyen
                      gerçek ve tüzel kişilerin yükümlülükleri belirlemek
                      amacıyla çıkarılmış olan 6698 sayılı Kişisel Verilerin
                      Korunması Kanunu (“KVKK”) hakkında sizleri bilgilendirmek
                      isteriz. {kurumBilgileri?.kisaTanim} olarak kişisel
                      verilerinizin güvenliği hususuna azami hassasiyet
                      göstermekteyiz. Bu bilinçle, hizmet faaliyetlerimizden
                      faydalanan vatandaşlarımız dahil,{" "}
                      {kurumBilgileri?.kisaTanim} bünyesinde ilişkili tüm
                      şahıslara ait her türlü kişisel verilerin 6698 sayılı
                      Kişisel Verilerin Korunması Kanunu (“KVK Kanunu”)’na uygun
                      olarak işlenerek, muhafaza edilmesine büyük önem
                      atfetmekteyiz. Bu sorumluluğumuzun tam idraki ile KVK
                      Kanunu’nda tanımlı şekli ile “Veri Sorumlusu” sıfatıyla,
                      kişisel verilerinizi aşağıda izah edildiği surette ve
                      mevzuat tarafından verilen sınırlar çerçevesinde
                      işlemekteyiz. KVK Kanunu Hakkında detaylı bilgi almak için
                      Kişisel Verileri Koruma Kurumu’nun internet sayfasını
                      ziyaret edebilirsiniz.
                    </h6>
                    <h4>
                      <b>
                        1. {kurumBilgileri?.kisaTanim} kişisel verilerin
                        toplanmasında hangi yöntemleri kullanıyor
                      </b>
                    </h4>
                    <h6>
                      {SERVER_URL} ve diğer kurumsal web sitelerimiz ,
                      e-belediye ,{kurumBilgileri?.kisaTanim} e- devlet kısmı
                      üzerinden işlem yapan vatandaşlarımızın verdikleri
                      veriler, vatandaşlarımızın rızaları ve mevzuat hükümleri
                      uyarınca {kurumBilgileri?.kisaTanim} tarafından
                      işlenmektedir.
                    </h6>
                    <h4>
                      <b>
                        2. Kayıtlara Ait Kişisel Verilerin İşlenme Amacı ve
                        Aktarımı
                      </b>
                    </h4>
                    <h6>
                      Kişisel verileriniz şu amaçlarla kullanılmaktadır:{" "}
                      <ul>
                        <li>
                          Kurumsal web sitemiz ve mobil uygulamalar üzerinden
                          işlem yapanın / yaptıranın kimlik bilgilerini teyit
                          etmek,
                        </li>
                        <li>
                          Halk Masası üzerinden yapılan bildirimlere dair
                          iletişim için adres ve diğer gerekli bilgileri
                          kaydetmek,
                        </li>
                        <li>
                          Elektronik ortam ve platformlarda (internet/mobil vs.)
                          veya kağıt ortamında işleme dayanak olacak tüm kayıt
                          ve belgeleri düzenlemek,
                        </li>
                        <li>
                          Kamu güvenliğine ilişkin hususlarda talep halinde ve
                          mevzuat gereği kamu görevlilerine bilgi verebilmek,
                        </li>
                        <li>
                          Vatandaşlarımızın memnuniyetini artırmak, web sitesi
                          ve/veya mobil uygulamalardan işlem yapan
                          vatandaşlarımızı tanıyabilmek ve vatandaş çevresi
                          analizinde kullanabilmek, çeşitli kamusal
                          faaliyetlerinde kullanabilmek ve bu kapsamda anlaşmalı
                          kuruluşlar aracılığıyla elektronik ortamda ve/veya
                          fiziki ortamda anketler düzenlemek,
                        </li>
                        <li>
                          Vatandaşlarımıza öneri sunabilmek, hizmetlerimizle
                          ilgili vatandaşlarımızı bilgilendirebilmek,
                        </li>
                        <li>
                          Hizmetlerimiz ile ilgili şikayet, istek ve önerilerini
                          değerlendirebilmek,
                        </li>
                        <li>
                          Yasal yükümlülüklerimizi yerine getirebilmek ve
                          yürürlükteki mevzuattan doğan haklarımızı
                          kullanabilmek,
                        </li>
                      </ul>
                    </h6>
                    <h4>
                      <b>
                        3. {kurumBilgileri?.kisaTanim} kişisel verileri hangi
                        koşullar altında korunuyor?
                      </b>
                    </h4>
                    <h6>
                      {kurumBilgileri?.kisaTanim} ile paylaşılan kişisel
                      veriler,
                      {kurumBilgileri?.kisaTanim} gözetimi ve kontrolü
                      altındadır.
                      {kurumBilgileri?.kisaTanim}, yürürlükteki ilgili mevzuat
                      hükümleri gereğince bilginin gizliliğinin ve bütünlüğünün
                      korunması amacıyla gerekli organizasyonu kurmak ve teknik
                      önlemleri almak ve uyarlamak konusunda veri sorumlusu
                      sıfatıyla sorumluluğu üstlenmiştir. Bu konudaki
                      yükümlülüğümüzün bilincinde olarak veri gizliliğini konu
                      alan teknik standartlara uygun surette periyodik
                      aralıklarda sızma testleri yaptırılmakta ve bu kapsamda
                      veri işleme politikalarımızı her zaman güncellediğimizi
                      bilginize sunarız.
                    </h6>
                    <h4>
                      <b>
                        4. Kişisel Verilerin Korunması Kanunu’ndan doğan
                        haklarınız nelerdir?
                      </b>
                    </h4>
                    <h6>
                      Belediyemize başvurarak KVKK uyarınca kişisel
                      verilerinizin;{" "}
                      <ul>
                        <li>Kişisel veri işlenip işlenmediğini öğrenme,</li>
                        <li>
                          Kişisel verileri işlenmişse buna ilişkin bilgi talep
                          etme,
                        </li>
                        <li>
                          Kişisel verilerin işlenme amacını ve bunların amacına
                          uygun kullanılıp kullanılmadığını öğrenme,
                        </li>
                        <li>
                          Yurt içinde veya yurt dışında kişisel verilerin
                          aktarıldığı üçüncü kişileri bilme,
                        </li>
                        <li>
                          Kişisel verilerin eksik veya yanlış işlenmiş olması
                          hâlinde bunların düzeltilmesini isteme ve bu kapsamda
                          yapılan işlemin kişisel verilerin aktarıldığı üçüncü
                          kişilere bildirilmesini isteme,
                        </li>
                        <li>
                          KVK Kanunu’nun ve ilgili diğer kanun hükümlerine uygun
                          olarak işlenmiş olmasına rağmen, işlenmesini
                          gerektiren sebeplerin ortadan kalkması hâlinde kişisel
                          verilerin silinmesini veya yok edilmesini isteme ve bu
                          kapsamda yapılan işlemin kişisel verilerin aktarıldığı
                          üçüncü kişilere bildirilmesini isteme,
                        </li>
                        <li>
                          İşlenen verilerin münhasıran otomatik sistemler
                          vasıtasıyla analiz edilmesi suretiyle kişinin kendisi
                          aleyhine bir sonucun ortaya çıkmasına itiraz etme,
                        </li>
                        <li>
                          Kişisel verilerin kanuna aykırı olarak işlenmesi
                          sebebiyle zarara uğraması hâlinde zararın
                          giderilmesini talep etme
                        </li>
                      </ul>
                      haklarına sahiptir. Bu amaçlarla yaptığınız başvurunun ek
                      bir maliyet gerektirmesi durumunda, Kişisel Verileri
                      Koruma Kurulu tarafından belirlenecek tarifedeki ücret
                      tutarını ödemeniz gerekebilir. Başvurunuzda yer alan
                      talepleriniz, talebin niteliğine göre en kısa sürede ve en
                      geç 30 (otuz) gün içinde sonuçlandırılacaktır.
                    </h6>
                    <h6>
                      Kanun kapsamında başvuru yapabileceğiniz veri sorumlusu:{" "}
                      {kurumBilgileri?.kisaTanim}
                    </h6>
                  </span>
                    </div>
                  </IonCardContent>
                </IonCard>
                <IonButton onClick={() => setShowKVKKModal(false)}>Tamam</IonButton>
              </IonContent>
            </IonModal>
            <IonModal
              isOpen={showSecInfoModal}
              canDismiss
              className="disclaimer-modal"
              onDidDismiss={() => setShowSecInfoModal(false)}
            >
              <IonContent className="ion-text-center">
                <IonCard>
                  <IonCardHeader>
                    <IonCardTitle>GÜVENLİK UYARILARI</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent>
                    <div style={{textAlign: "justify"}}>
                  <span style={{textAlign: "justify"}}>
                    <p>
                      &#160;&#160;&#160;&#160; {kurumBilgileri?.kisaTanim}{" "}
                      {kurumBilgileri?.kurumKodu?.startsWith("35")
                        ? "Online İşlemler"
                        : kurumBilgileri?.kurumKodu?.startsWith("48")
                          ? "E-Birlik Hizmetleri"
                          : "E-Belediye Hizmetleri"}{" "}
                      sayfası vasıtasıyla gerçekleştirdiğiniz tüm işlemler
                      şifreli olup dünyaca kabul görmüş güvenlik sertifaları
                      kullanılmaktadır. Kredi kartı ile yapacağınız ödemelerde
                      bankaların güvenli ödeme noktaları kullanılmakta olup,
                      kredi kartı ile ilgili herhangi bir bilgi sistemimize
                      kayıt <u>edilmemektedir.</u>
                    </p>
                    <p>
                      &#160;&#160;&#160;&#160; Kişisel bilgilerinizin korunması
                      ve gerekli güvenlik önlemlerinin alınması bakımından siz
                      değerli mükelleflerimize birkaç önemli hatırlatmada
                      bulunmak istiyoruz.
                    </p>
                    <ul>
                      <li>
                        Güvenlik açısından TC Kimlik No, sicil numarası gibi
                        özel bilgilerinizle şifrenizi üçüncü şahıslarla
                        paylaşmayınız.{" "}
                      </li>
                      <li>
                        Şifrenizi belirlerken herkesin kolayca tahmin
                        edebileceği isim, yaşgünü, telefon numarasi vb.
                        kullanmayınız. Şifrenizi güvenli bir yerde saklayınız ve
                        bilgisayarınıza kayıt etmeyiniz.
                      </li>
                      <li>
                        Yönlendirildiğiniz sayfanın https:// ile başladığından
                        emin olunuz.{" "}
                        {kurumBilgileri?.kurumKodu?.startsWith("35")
                          ? "Online İşlemler"
                          : kurumBilgileri?.kurumKodu?.startsWith("48")
                            ? "E-Birlik Hizmetleri"
                            : "E-Belediye Hizmetleri"}{" "}
                        sayfası 128 bit SSL şifreleme kullanmaktadır. Açılan
                        ödeme penceresinde kullandığınız tarayıcıya göre sağ alt
                        ya da sağ üstte bulunan kilit işaretine tıkladığınızda
                        açılan sertifikanın geçerli olup olmadığını kontrol
                        ediniz.
                      </li>
                      <li>
                        İnternet kafe gibi halka açık yerlerden işlem
                        yapıyorsanız dikkatli olunuz. ( Zorunlu olmadıkça bu tür
                        yerlerden işlem yapmayınız! )
                      </li>
                      <li>
                        Bilgisayarınızda mutlaka orijinal anti-virüs yazılımı
                        kullanınız. Sisteminizi düzenli aralıklarla anti-virüs
                        yazılımı ile tarayınız ve anti-virüs yazılımınızı
                        düzenli olarak güncelleyiniz. İnternetten indirdiğiniz
                        her türlü dosyayı mutlaka anti-virüs yazılımıyla kontrol
                        ediniz. Ancak, anti-virüs yazılımlarının, sadece bilinen
                        virüsleri tarayabilecegini unutmayınız.
                      </li>
                      {!kurumBilgileri?.kurumKodu?.startsWith("35") && (
                        <li>
                          Üye Girişi yaptıktan sonra işlemleriniz bittiğinde
                          "Güvenli Çıkış" butonunu ile oturumunuzu sonlandırıp
                          daha sonra tarayıcınızı kapatınız.
                        </li>
                      )}
                    </ul>
                  </span>
                    </div>
                  </IonCardContent>
                </IonCard>
                <IonButton onClick={() => setShowSecInfoModal(false)}>
                  Tamam
                </IonButton>
              </IonContent>
            </IonModal>
            </IonCardContent>
          </IonCard>
        )}
      </IonContent>
    </IonPage>
  );
};

export default EdevletLogin;
